import type { Settlement } from '../engine/map/settlement';

export function runGrabToolTick(settlement: Settlement): boolean {
    let changed = false;

    const assignTools = (needed: number, tools: Settlement['tools'][keyof Settlement['tools']]) => {
        while (tools.length < needed && settlement.inventory.tools.length > 0) {
            const tool = settlement.inventory.tools.pop();
            if (!tool) break;
            tools.push(tool);
            changed = true;
        }
    };

    assignTools(settlement.jobs.farmers, settlement.tools.farmers);
    assignTools(settlement.jobs.hunters, settlement.tools.hunters);

    return changed;
}
